// A Google account connected to a Rolodex account. The Rolodex account is still keyed by its own address
// (users.email); the connection lets "Sign in with Google" as the Google address land in that account,
// and, when the Google account is made primary, Rolodex emails go to the Google address instead.
//   • a person connects their own from Settings › Account (a Google sign-in proves it's theirs);
//   • an administrator connects one by address from Administration › Users (confirmed the first time
//     that Google account signs in).
// The table DDL lives in the worker (db/schema.ts ensureIdentityTables, migration 0046).
import { z } from 'zod';
export const GooglePrimarySchema = z.object({ primary: z.boolean() });
export const AdminGoogleLinkSchema = z.object({
    email: z.string().email(),
    google: z.string().trim().email('Enter the Google account address'),
});
export const AdminGooglePrimarySchema = z.object({ email: z.string().email(), primary: z.boolean() });
export const AdminGoogleUnlinkSchema = z.object({ email: z.string().email() });
/** may this Google address be connected to this account? A Google address can belong to one Rolodex
 *  account only. If it already has an account of its own, that's only taken over when it's a stray one:
 *  made automatically by an earlier Google sign-in and never approved (pending), so it holds nothing. */
export function planIdentityLink(f) {
    const account = f.account.toLowerCase();
    const address = f.address.toLowerCase();
    if (f.connectedTo && f.connectedTo.toLowerCase() !== account) {
        return { ok: false, reason: `${address} is already connected to ${f.connectedTo}.` };
    }
    if (address !== account && f.addressAccount) {
        if (f.addressAccount.pending && !f.addressAccount.protected)
            return { ok: true, removeStray: true };
        return {
            ok: false,
            reason: `${address} has its own Rolodex account. An administrator can delete that account first, then connect it here.`,
        };
    }
    return { ok: true, removeStray: false };
}
/** disconnecting would leave no way in: signing in with Google as that address would no longer reach
 *  this account (it isn't the account's own address) and there's no password to fall back on. */
export function unlinkLeavesNoSignIn(account, address, hasPassword) {
    return !hasPassword && account.toLowerCase() !== address.toLowerCase();
}
/** where each recipient's email goes: a person whose Google account is primary gets it at the Google
 *  address. `primary` maps a Rolodex address (lower case) to that Google address. Keeps the order and
 *  drops repeats. */
export function deliveryAddresses(recipients, primary) {
    const out = [];
    const seen = new Set();
    for (const r of recipients) {
        const to = primary.get(r.trim().toLowerCase()) ?? r;
        const key = to.trim().toLowerCase();
        if (!key || seen.has(key))
            continue;
        seen.add(key);
        out.push(to);
    }
    return out;
}
//# sourceMappingURL=identity.js.map